// extracted by mini-css-extract-plugin
export default {"admin__container":"style_admin__container__wArbe","admin__nav":"style_admin__nav__e3IK8","admin__content":"style_admin__content__wRaXz"};